import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base-service.template';
import { ApiResponseModel } from '../../../public-api';
import { ApiVisa } from '../../models/base/apivisa.model';
import { getHttpHeader } from '../../utils/http-header.factory';

export class GetByGuidService<T> implements BaseService {
    
  public readonly apiUrl: string;
  protected readonly http: HttpClient;

  constructor(url: string, http: HttpClient) { 
    this.http = http;
    this.apiUrl = url;
  }

  public getByGuid(guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<T>>{
    return this.http.get<ApiResponseModel<T>>(`${ api_domain_url }${ this.apiUrl }/${ guid }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
